import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		wrapper: 'bg-black py-5 md:py-7',
		base: 'flex max-xl:flex-wrap lg:max-w-[172rem] mx-auto px-2 md:px-4 justify-between w-full',
		list: 'grid grid-cols-1 sm:grid-cols-2 gap-2 xl:gap-4 mt-2 xl:mt-0 w-full md:max-w-[95rem]',
	},
})

export type StylesVariants = VariantProps<typeof styles>
